import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-add-solid",
  "use": "icon-add-solid-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol viewBox=\"0 0 32 32\" id=\"icon-add-solid\"><path d=\"M16 2c7.8 0 14 6.2 14 14s-6.2 14-14 14S2 23.8 2 16 8.2 2 16 2m1 6h-2v7H8v2h7v7h2v-7h7v-2l-7-.001z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol